<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pyhACJ/tc-custom/9781642795943.jpg?1720831547790" alt="This image is the cover for the book Taking Back Your Health and Happiness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taking Back Your Health and Happiness
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Taking Back Your Health and Happiness</i> helps those who suffer from chronic pain discover the source of their pain to achieve self-healing and happiness within.</b><p> As a nurse for over ten years, an energy healer, and spiritual intuitive healer, Marie Anne June L. Tagorda has seen the effects illness has on people and their loved ones. She herself has had her share of chronic pain and invisible illness. In <i>Taking Back My Health and Happiness</i>, she shares her process for achieving self-healing and happiness. Within <i>Taking Back My Health and Happiness</i>, those who suffer from chronic pain learn:</p><p>The source and meaning of their chronic pain and illnessHow to deal with their condition in order to live happy and be free to enjoy life How to effectively communicate with loved ones to include them in their care and not be burdened by it The obstacles blocking their healing (and how to overcome them) Tips for healing their body while healing their relationships</p><p> One’s illness does not define them, and they can begin the process to becoming happy, healthy, and free to enjoy life today with <i>Taking Back Your Health and Happiness</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Anne June L. Tagorda
      </h2>
      
      <p class="authorDescription body article">Marie Anne June L. Tagorda is a medical intuitive energy healer and spiritual intuitive adviser who specializes in releasing emotional trauma and healing the wounds of the past while rejuvenating the energetic connection between the mind, body, and heart. As a critical care registered nurse and life coach with a lifetime of experience as an oracle and intuitive healer, Marie Anne helps clients identify the root issues of their lives, bodies, minds, and spirits and helps them clear away the blockages that keep them from authentically living their best lives. She completed Body and Brain Healer’s School in Sedona in 2007. She is also a Brain Management Consultant and a graduate of Power Brain Education. Marie Anne currently resides in Bellerose, NY.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?572cd913